import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "details" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "favorite", -1)
const _hoisted_6 = [
  _hoisted_5
]

import { getCollection } from '@/composables/getCollection';
import CreateBookForm from '../components/CreateBookForm.vue'
import { db } from "../firebase/config"
import { doc, deleteDoc, updateDoc } from "firebase/firestore"
// import { getUser } from '@/composables/getUser'

// const { user } = getUser()


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { documents } = getCollection(
  'books',
  // ['userUid', '===', user.value?.uid]
)

const handleDelete = (document: { id: string }) => {
  const docRef = doc(db, 'books', document.id)

  deleteDoc(docRef)
}

const handleUpdate = (document: { id: string; isFav: any; }) => {
  const docRef = doc(db, 'books', document.id)

  updateDoc(docRef, {
    isFav: !document.isFav
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documents), (document) => {
        return (_openBlock(), _createElementBlock("li", {
          key: document.id
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", {
              onClick: ($event: any) => (handleDelete(document))
            }, _toDisplayString(document.title), 9, _hoisted_3),
            _createElementVNode("p", null, "By " + _toDisplayString(document.author), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({ icon: true, fav: document.isFav }),
            onClick: ($event: any) => (handleUpdate(document))
          }, _hoisted_6, 10, _hoisted_4)
        ]))
      }), 128))
    ]),
    _createVNode(CreateBookForm)
  ]))
}
}

})